// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ChartContract = contract({
  name: "Chart",
  description: "Reporting dashboards, single-purpose analytics cards (revenue, conversions, active users), or anywhere you'd otherwise hand-roll a Recharts setup. Bring the actual chart type from `recharts` — ChartContainer doesn't pick the chart shape for you, it themes whatever you nest. For sparkline-style decorative trends consider just rendering a small SVG line directly; ChartContainer is overkill for non-interactive ornament.",
  import: "@gradeui/ui",
  aliases: ["chart","charts","graph","bar chart","line chart","area chart","recharts","analytics chart","swift chart","swiftui chart","victory chart","victory native"],
  subcomponents: ["ChartTooltip","ChartTooltipContent","ChartLegend","ChartLegendContent","ChartStyle"],
  composesWith: ["Card (chart-in-a-card pattern)","Tabs (multi-metric switcher)","Recharts components (Bar","Line","Area","Pie","Radar from \"recharts\")"],
  styleDefaults: {"ChartContainer":"flex aspect-video justify-center text-xs [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none","ChartTooltipContent":"font-medium","ChartLegendContent":"flex items-center justify-center gap-4"},
  props: {
  "config": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "`{ [seriesKey]: { label: string; color?: string; theme?: { light: string; dark: string } } }`; the keys here are the names you reference in your Recharts <Bar dataKey=\"…\" /> calls",
  },
  "id": {
      schema: z.string().optional(),
      design: "plumbing",
      description: "used for the inlined <style> tag",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "typically a single Recharts ResponsiveContainer or chart",
  },
  "content": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "pair with `content={<ChartTooltipContent />}`; passes through to Recharts <Tooltip>",
  },
  "cursor": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "the hover crosshair/highlight; Recharts passthrough",
  },
  "indicator": {
      schema: z.enum(["dot", "line", "dashed"]).optional(),
      design: "knob",
  },
  "hideLabel": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "hideIndicator": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "nameKey": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "labelKey": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  },
});
